import { render, staticRenderFns } from "./OrganizationLetterModal.vue?vue&type=template&id=ee061a58"
import script from "./OrganizationLetterModal.vue?vue&type=script&lang=js"
export * from "./OrganizationLetterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports